var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 20,
    height: 20,
    transform: "translate(20 115)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_52",
    "data-name": "Mask Group 52",
    transform: "translate(-20 -115)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(19.333 114.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 18.667,
    height: 18.667,
    rx: 2.667,
    transform: "translate(1.333 1.333)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M13.333,16V9.333",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M16,16V5.333",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M5.333,16V13.333",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M8,10.667V16",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M10.667,12v4",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardGray);
export default __webpack_public_path__ + "static/media/dashboard-gray.5e9f6150e8da687953552e58acd95b1b.svg";
export { ForwardRef as ReactComponent };